import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16",
  fillRule: "evenodd"
});

var SvgChevronRightMinor = function SvgChevronRightMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgChevronRightMinor as S };
